const LABELS = {
  solo: 'Solo',
  team: 'Team',
  monthly: 'Fokus Pro',
  annual: 'Fokus Pro',
};

const PRICE_PLANS = {
  price_1U69a8KMPq2kqUCJTkgyyv9x: 'solo',
  price_1U69a8KMPq2kqUCJUkofGHL7: 'team',
  price_1U6bS53sNo4Cwp3cqgWl4QH5: 'solo',
  price_1U6bS63sNo4Cwp3cho7YyxeO: 'team',
};

/** Solo is just you. Team, complimentary, and older paid plans may invite. */
export function accountCanInvite(sub = {}) {
  if (sub.complimentary) return true;
  return resolvePlanType(sub) !== 'solo';
}

export function resolvePlanType({ plan, planId } = {}) {
  const fromMeta = String(plan || '').toLowerCase();
  if (LABELS[fromMeta]) return fromMeta;
  return PRICE_PLANS[planId] || '';
}

export function planLabel(sub = {}) {
  if (sub.complimentary) return 'Complimentary';
  const type = resolvePlanType(sub);
  if (type && LABELS[type]) return LABELS[type];
  if (sub.hasAccess) return 'Active';
  if (sub.status === 'canceled') return 'Canceled';
  return 'No plan';
}

export function planDetail(sub = {}) {
  const type = resolvePlanType(sub);
  if (type === 'solo') return '$30 / month · just you';
  if (type === 'team') {
    const seats = Number(sub.quantity) > 0 ? Number(sub.quantity) : 1;
    const each = 40;
    return `$${each} / seat · ${seats} seat${seats === 1 ? '' : 's'} · $${each * seats} / month`;
  }
  if (type === 'monthly') return '$12 / month';
  if (type === 'annual') return '$99 / year';
  if (sub.complimentary) return 'You have access to this brain. Not a paid plan.';
  if (sub.hasAccess) return 'This brain has access.';
  return 'Pick Solo or Team for this brain.';
}

/** Room name for Plan copy. */
export function workspaceDisplayName(workspace) {
  const name = (workspace?.name || '').trim();
  return name || 'This brain';
}

/**
 * What Plan should show for this room.
 * A plan on the workspace wins. Complimentary still means access.
 * Otherwise we fall back to the account bill (honest, until rooms bill themselves).
 */
export function resolveWorkspacePlan(workspace, accountSub = {}) {
  if (accountSub.complimentary) {
    return { ...accountSub, complimentary: true, source: 'complimentary' };
  }
  if (workspace?.plan || workspace?.planId) {
    return {
      plan: workspace.plan || null,
      planId: workspace.planId || null,
      quantity: workspace.quantity || null,
      hasAccess: workspace.covered !== false,
      source: 'workspace',
    };
  }
  const named =
    workspace?.id &&
    workspace.id !== 'personal' &&
    workspace.id !== '';
  if (named) {
    return { source: 'none', hasAccess: workspace.covered === true };
  }
  if (resolvePlanType(accountSub) || accountSub.hasAccess) {
    return { ...accountSub, source: 'account' };
  }
  return { source: 'none', hasAccess: false };
}

/** Invites follow this room’s plan. Complimentary can invite anywhere. */
export function workspaceCanInvite(workspace, accountSub = {}) {
  if (accountSub.complimentary) return true;
  const named =
    workspace?.id &&
    workspace.id !== 'personal' &&
    workspace.id !== '';
  if (named) {
    const type = resolvePlanType(workspace);
    if (type === 'solo') return false;
    if (type === 'team' || type === 'monthly' || type === 'annual') return true;
    return false;
  }
  return accountCanInvite(accountSub);
}

export function planLabelForWorkspace(workspace, accountSub = {}) {
  return planLabel(resolveWorkspacePlan(workspace, accountSub));
}

export function planDetailForWorkspace(workspace, accountSub = {}) {
  return planDetail(resolveWorkspacePlan(workspace, accountSub));
}

export function planNoteForWorkspace(workspace, accountSub = {}, { isOwner } = {}) {
  if (!isOwner) {
    if (workspace?.covered === false) {
      return 'The owner of this brain needs to add a plan.';
    }
    return 'The owner pays for this brain. You do not.';
  }
  const resolved = resolveWorkspacePlan(workspace, accountSub);
  if (resolved.source === 'account') {
    return 'This bill is still on your account. Soon each brain will have its own.';
  }
  return '';
}

export function workspaceNeedsPlanPick(workspace, accountSub = {}, { isOwner } = {}) {
  if (!isOwner) return false;
  if (accountSub.complimentary) return false;
  return resolveWorkspacePlan(workspace, accountSub).source === 'none';
}
